/** @private  */
export const Redacted = '[:REDACTED:]'; // distinguish from redacted string returned by the redact library.
//# sourceMappingURL=shared.js.map